import { omitBy } from 'lodash';
import { useLocation } from 'react-router-dom';
import type { ParsedQuery } from 'query-string';
import { parse as parseQuery, stringify as stringifyQuery } from 'query-string';

export interface UrlFormatterArgs {
  queryParams: ParsedQuery;
  location: ReturnType<typeof useLocation>;
  formatUrl: (
    updatedQueryParams: Record<string, unknown>,
    pathname?: string,
  ) => string;
}

const useUrlFormatter = <T>(
  formatHandler: (args: UrlFormatterArgs) => T,
): T => {
  const location = useLocation();
  const queryParams = parseQuery(location.search);
  const formatUrl = (
    updatedQueryParams: Record<string, unknown>,
    pathname: string = location.pathname,
  ) => {
    const qp = stringifyQuery(omitBy(updatedQueryParams, (d) => d == null));
    return `${pathname}${qp ? `?${qp}` : ''}`;
  };

  return formatHandler({ queryParams, location, formatUrl });
};

export default useUrlFormatter;
